import { createApp } from 'vue'
import { isDesktop } from '~/js/templates/index/helpers'
import FLinkCard from '~/js/components/linkCard'
import FSlider from '~/js/components/slider'
import { LinkItem } from '~/js/models/linkItem'

const ID = 'js-collectionArticles'

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById(ID)
  if (!element) return

  const linkItems = JSON.parse(element.dataset.linkItems).map(
    (linkItem) => new LinkItem(linkItem)
  )

  createApp({
    name: 'TemplatesCollectionArticles',
    data() {
      return { linkItems, isDesktop: isDesktop() }
    },
    components: {
      FLinkCard,
      FSlider,
    },
    created() {},
  }).mount(element)
})
